import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Row } from 'react-bootstrap';
import UserSelectorContainer from '../Containers/UserSelectorContainer';

const LoginModalComponent = ({
  visible,
  onHide,
  redirectFunc
}) => (
  <Modal show={visible} onHide={onHide} bsSize="lg">
    <Modal.Header closeButton>
      <Modal.Title>Dashboard Login</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <Row>
        <UserSelectorContainer redirectFunc={redirectFunc} />
      </Row>
    </Modal.Body>
  </Modal>
);

LoginModalComponent.propTypes = {
  visible: PropTypes.bool,
  onHide: PropTypes.func.isRequired,
  redirectFunc: PropTypes.func
};

export default LoginModalComponent;


// WEBPACK FOOTER //
// src/Components/LoginModalComponent.jsx